import { useCallback } from "react"
import { IPerfil } from "../../application/models/IPerfil"
import { delay } from "../../utils/delay"
import { useAxiosInstances } from "../axios-instance"
import { IProdutoTipoConsumo } from "../../application/models"

export const usePerfilApi = () => {
  const { axiosAuthInstance } = useAxiosInstances()

  const getPerfisByIdClienteApi = useCallback(async (data: {
    idCliente: number
    page: number
    limit: number
  }): Promise<{
    perfis: IPerfil[]
    total: number
  }> => {
    try {
      const result = await axiosAuthInstance.get(`/perfil/cliente/${data.idCliente}`, {
        params: {
          Page: data.page,
          Limit: data.limit
        }
      })

      return {
        perfis: result.data.perfis,
        total: result.data.total
      }
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const createPerfilApi = useCallback(async (data: {
    name: string,
    idCliente: number
  }): Promise<IPerfil> => {
    try {
      const result = await axiosAuthInstance.post('/perfil/', {
        IdCliente: data.idCliente,
        Descricao: data.name
      })

      return result.data.perfil
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const getPerfilByIdPerfilApi = useCallback(async (data: {
    idPerfil: number
  }): Promise<IPerfil> => {
    try {
      const result = await axiosAuthInstance.get(`/perfil/${data.idPerfil}`)

      return result.data.perfil
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const updatePerfilProdutosVinculados = useCallback(async (data: {
    id: string
  }): Promise<void> => {
    await delay(1551)
    return

  }, [])

  const updatePerfilApi = useCallback(async (data: {
    idPerfil: number
    name: string
    status: boolean
    produtosTipoConsumo: IProdutoTipoConsumo[]
  }): Promise<IPerfil> => {
    try {
      const requestBody = {
        Descricao: data.name,
        Ativo: data.status,
        ProdutosTipoConsumo: data.produtosTipoConsumo
      }
      
      const result = await axiosAuthInstance.put(`/perfil/${data.idPerfil}`, requestBody)

      return result.data.perfil
    } catch (error) {
      throw error
    }
  }, [axiosAuthInstance])

  const getProdutosVinculadosApi = useCallback(async (data: {
    IdCliente: number
    IdPerfil: number
  }): Promise<IProdutoTipoConsumo[]> => {
    try {
      
      const result = await axiosAuthInstance.get('/perfil/produto-tipo-consumo', {
        params: {
          IdCliente: data.IdCliente,
          IdPerfil: data.IdPerfil
        }
      })


      return result.data.produtos
    } catch (error) {
      console.error('Error:', error)
      throw error
    }
  }, [axiosAuthInstance])

  return {
    createPerfilApi,
    getPerfisByIdClienteApi,
    getPerfilByIdPerfilApi,
    updatePerfilProdutosVinculados,
    updatePerfilApi,
    getProdutosVinculadosApi
  }
}